import { useEffect, useState } from 'react';
import GreatestListsText from '../source-data/GreatestLists.txt';
import YearlyListsText from '../source-data/GOTY Lists.txt';
import Ufo50ListText from '../source-data/Ufo50.txt'

// import text in js and then export to tsx for use.  Simplest way identified to work with.
export { Ufo50ListText };

export const useGetGreatestListRaw = () => {
    const [fileData, setFileData] = useState('');
    
    useEffect(() => {
        fetch(GreatestListsText)
        .then(r => r.text())
        .then(text => {
            setFileData(text)  
        })
    }, [])

    return fileData;
}

export const useGetYearlyListRaw = () => {
    const [yearlyFileData, setYearlyFileData] = useState('');
    
    useEffect(() => {
        fetch(YearlyListsText)
        .then(r => r.text())
        .then(text => {
            setYearlyFileData(text)  
        })
    }, [])

    return yearlyFileData;
}

export const useReadTextFileRaw = (fileSource) => {
    const [rawFileData, setRawFileData] = useState('');

    useEffect(() => {
        fetch(fileSource)
        .then(r => r.text())
        .then(text => {
            setRawFileData(text)  
        })
    }, [fileSource])

    return rawFileData;
}
